import { handleActions } from '@housinganywhere/safe-redux';

import { BillingSubscriptionProduct } from 'ha/services/apiV2/types/Subscriptions';
import { ActionsType, ActionTypes } from '../actions/loadProduct';

interface State {
  product?: BillingSubscriptionProduct;
  loading: boolean;
  error: boolean;
}

export const initialState: State = {
  product: undefined,
  error: false,
  loading: false,
};

export default handleActions<State, ActionTypes, ActionsType>(
  {
    [ActionTypes.START]: state => ({
      ...state,
      error: false,
      loading: true,
    }),
    [ActionTypes.DONE]: (state, { payload }) => ({
      ...state,
      product: payload,
      loading: false,
      error: false,
    }),
    [ActionTypes.FAIL]: state => ({
      ...state,
      error: true,
      loading: false,
    }),
  },
  initialState,
);
